import Content from "./Content";
import ContentFactory from "./ContentFactory";

/**
 * @namespace ranj
 * @param {Object} ranj
 */
export default class QuizAnswerScaleContent extends Content {

    constructor(languagePack, contentID, answerTitle, label) {
        super(QuizAnswerScaleContent.NAME, QuizAnswerScaleContent.TYPE, label, languagePack, contentID);

        this._answerTitle = answerTitle;
        this._minValue;
        this._maxValue;
        this._correctValue;
        this._answerRange;
        this._stepSize;
        this._points;
        this.setAnswerTitle(label);
    }

    remove() {
        this.removeLanguagePackText(QuizAnswerScaleContent.ANSWER_TITLE_LABEL);
        super.remove();
        this.dispatchEvent("propertyChange");
    }

    clone() {
        let clone;
        clone = QuizAnswerScaleContent(ContentFactory.getContent(QuizAnswerScaleContent.TYPE, this.languagePack));
        clone.contentID = this.contentID;
        clone._answerTitle = this._answerTitle;
        clone._minValue = this._minValue;
        clone._maxValue = this._maxValue;
        clone._correctValue = this._correctValue;
        clone._answerRange = this._answerRange;
        clone._stepSize = this._stepSize;
        clone._points = this._points;
        return clone;
    }

    setAnswerTitle(value) {
        if (this._answerTitle !== value) {
            this.setLanguagePackText(QuizAnswerScaleContent.ANSWER_TITLE_LABEL, value);
            this.dispatchEvent("propertyChange");
        }
    }

    getAnswerTitle() {
        return this.getLanguagePackText(QuizAnswerScaleContent.ANSWER_TITLE_LABEL);
    }

    setAnswerDescription(value) {
        this.setLanguagePackText(QuizAnswerScaleContent.ANSWER_DESCRIPTION_LABEL, value);
    }

    getAnswerDescription() {
        return this.getLanguagePackText(QuizAnswerScaleContent.ANSWER_DESCRIPTION_LABEL);
    }

    setAnswerVariable(value) {
        this.setLanguagePackText(QuizAnswerScaleContent.ANSWER_VARIABLE, value);
    }

    getAnswerVariable() {
        return this.getLanguagePackText(QuizAnswerScaleContent.ANSWER_VARIABLE);
    }

    setUnitText(value) {
        this.setLanguagePackText(QuizAnswerScaleContent.UNIT_TEXT_LABEL, value);
    }

    getUnitText() {
        return this.getLanguagePackText(QuizAnswerScaleContent.UNIT_TEXT_LABEL);
    }

    setMinValue(minValue) {
        this._minValue = minValue;
    }

    getMinValue() {
        return this._minValue;
    }

    setMaxValue(maxValue) {
        this._maxValue = maxValue;
    }

    getMaxValue() {
        return this._maxValue;
    }

    setCorrectValue(correctValue) {
        this._correctValue = correctValue;
    }

    getCorrectValue() {
        return this._correctValue;
    }

    setAnswerRange(answerRange) {
        this._answerRange = answerRange;
    }

    getAnswerRange() {
        return this._answerRange;
    }

    setStepSize(stepSize) {
        this._stepSize = stepSize;
    }

    getStepSize() {
        return this._stepSize;
    }

    setPoints(points) {
        this._points = points;
    }

    getPoints() {
        return this._points;
    }

    convertToObject() {
        return this.getObject(["points"]);
    }
}


QuizAnswerScaleContent.NAME = "Quiz Answer Scale";
QuizAnswerScaleContent.TYPE = "engQuizAnswerScaleContent";
QuizAnswerScaleContent.ANSWER_TITLE_LABEL = "answerTitle";
QuizAnswerScaleContent.ANSWER_DESCRIPTION_LABEL = "answerDescription";
QuizAnswerScaleContent.ANSWER_VARIABLE = "answerVariable";
QuizAnswerScaleContent.UNIT_TEXT_LABEL = "unitText";

